export default "__VITE_PUBLIC_ASSET__d60f5889__"